import { motion } from "framer-motion";
import { HOW_IT_WORKS } from "@/data/content";
import ProductScreen from "@/components/ui-blocks/ProductScreen";
import TiltedScreen from "@/components/ui-blocks/TiltedScreen";

const SCENE_URL_MAP = {
  signup: "checkout.stripe.com · Starter",
  builder: "goldkey.studio/dashboard/builder",
  launch: "goldkey.studio/dashboard/launch",
};
const DEFAULT_SCENE_URL = "mail · friday morning";

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works"
      className="py-20 sm:py-28 lg:py-36 px-5 sm:px-6 lg:px-12"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-12 sm:mb-20">
          <div className="md:col-span-5">
            <p className="overline">How it works</p>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] mt-5 sm:mt-6">
              One founder.
              <br />
              <span className="italic text-aurora">Eighteen minutes.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-base sm:text-lg lg:text-xl text-neutral-700 leading-relaxed">
              Carla owns Lumi Skin Studio in Brookline. Below is her real
              first session with GoldKey - start to live, in plain English.
              Hover any step to see exactly what she did.
            </p>
          </div>
        </div>

        <div className="space-y-16 sm:space-y-24">
          {HOW_IT_WORKS.map((s, i) => {
            const flip = i % 2 === 1;
            return (
              <motion.div
                key={s.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8 }}
                data-testid={`how-step-${s.step}`}
                className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center"
              >
                <div className={`lg:col-span-5 ${flip ? "lg:order-2 lg:col-start-8" : ""}`}>
                  <div className="flex items-baseline gap-4">
                    <span className="font-serif italic text-5xl sm:text-6xl text-aurora leading-none">
                      {s.step}
                    </span>
                    {s.detail && (
                      <span className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">
                        {s.detail}
                      </span>
                    )}
                  </div>
                  <h3 className="font-serif text-3xl sm:text-4xl tracking-tight leading-[1.1] mt-4 sm:mt-6">
                    {s.title}
                  </h3>
                  <p className="text-neutral-700 mt-5 leading-relaxed text-base sm:text-lg">
                    {s.body}
                  </p>
                </div>
                <div className={`lg:col-span-7 ${flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
                  <TiltedScreen maxTilt={5}>
                    <ProductScreen
                      scene={s.scene}
                      embedUrl={s.embedUrl}
                      testid={`how-step-screen-${s.step}`}
                      url={SCENE_URL_MAP[s.scene] || DEFAULT_SCENE_URL}
                    />
                  </TiltedScreen>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
